import React from "react";
import { connect } from "react-redux";
import { getLotes, eliminarLote } from "./LoteService";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import "../../styles/Empresa.css";
import { Link } from "react-router-dom";
import { Modal, Row, Col, Container, Button } from 'react-bootstrap';
import Navbar from "../home/Navbar";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import visibility from '../../styles/icons/visibility.svg';
import deleteIcon from '../../styles/icons/delete.svg';
import ExclamacionIcon from '../../styles/icons/exclamation-circle.svg';
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";

class LotesPublicar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRecibo: {
        nombre: "",
        fechaImportacion: "",
        descripcion: "",
        cantDocumentos: "",
        tipoDocumento: "",
        estado: "",
        estadoMTESS: false
      },
      dialogEliminarLote: false,
      mostrarMensajeFlash: false,
      openPantallaCarga: false,
      lotes: [],
      page: 0,
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
      search: "",
      loading:true
    };
    localStorage.setItem("urlRaiz", window.location.href);
    this.tableRef = React.createRef();
  }

  handleDialogEliminarLote = (value) => {
    this.setState({
      dialogEliminarLote: value,
    });
  };

  handleEliminarLote = () => {
    this.setState({openPantallaCarga: true, dialogEliminarLote: false})
    eliminarLote(this.state.selectedRecibo.id).then(response => {
      if (response.error) {
        this.setState({
          mensajeFlashSeverity: "danger",
          mensajeFlash: response.mensaje,
          mostrarMensajeFlash: true,
          openPantallaCarga: false
        });
      } else {
        this.setState({
          mensajeFlash: "Lote y recibos asociados eliminados",
          mensajeFlashSeverity: "success",
          mostrarMensajeFlash: true,
          openPantallaCarga: false
        });
      }
      this.fetchLotes(0, this.state.pageSize, "");
      this.handleDialogEliminarLote(false);
      this.fetchLotes(0, this.state.pageSize, "");
      
    })
  }

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };
  handlePageSizeChange(event) {
    const pageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize, page: 0 }, () => {
      this.fetchLotes();
    });
  }

  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchLotes(newPage, this.state.pageSize, "");
      });
    }
  }

  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchLotes(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchLotes(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">1</a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">{totalPages}</a>
          </li>
        );
      }
    }

    return pages;
  }

  componentDidMount() {
    this.fetchLotes(0, this.state.pageSize, ""); // Página inicial, tamaño y búsqueda vacía
  }

  fetchLotes(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getLotes(page, pageSize, search).then(() => {
      this.setState({
        lotes: this.props.lotesData.lotes,
        page: this.props.lotesData.page,
        totalCount: this.props.lotesData.totalCount,
        totalPages: Math.ceil(this.props.lotesData.totalCount / pageSize),
        loading: false 
      });
    });
  }
  
  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchLotes(0, this.state.pageSize, this.state.search);
    });
  };
  render() {
    return (
      <div>
        <div className="dashboardContent">
          <div className="container-fluid">
          <PantallaCarga open={this.state.openPantallaCarga} />
          <Modal
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.dialogEliminarLote}
              onHide={() => this.handleDialogEliminarLote(false)}
              backdrop="static"
              keyboard="false"
            >
              <Container>
                <Modal.Body>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                      <img src={ExclamacionIcon} style={{margin: '40px'}}></img>
                    </Col>
                  </Row>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                      <p><strong>Estas Seguro que desea eliminar este lote y sus recibos asociados?</strong></p>
                    </Col>
                  </Row>
                  <Row style={{ background: "#EDF2F9" }}>
                    <Col>
                      <p><strong>Lote Nro:</strong> {this.state.selectedRecibo.id}</p>
                      <p><strong>Descripción: </strong>{this.state.selectedRecibo.descripcion}</p>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={() => this.handleDialogEliminarLote(false)} variant="contained">Cancelar</Button>
                  <Button onClick={this.handleEliminarLote} color="primary" autoFocus>
                    Aceptar
                  </Button>
                </Modal.Footer>
              </Container>
            </Modal>

            <MensajeFlash
              mensaje={this.state.mensajeFlash}
              severity={this.state.mensajeFlashSeverity}
              open={this.state.mostrarMensajeFlash}
              handleClose={this.handleCloseMensajeFlash} />

            <div className="sectionHeader">
              <h1 className="pageTitle"> Lotes Para Publicar </h1>
            </div>
            <Navbar
              menuActual={window.location.hash}
              seccionActual={'lotes'}
            />
                                                <div className="contentBuscador card">
              <form className="searchForm">
                <div className="input-group input-group-lg">
                  <span className="input-group-text border-0" id="basic-addon2">
                    <img src={search} />
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Buscar.."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={this.state.search}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </form>
            </div>
            <div className="contentPage card" style={{ padding: "0px" }}>
            {this.state.loading ? (
                <div className="d-flex justify-content-center p-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                </div>
              ) : (
                <div>
            <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Lote</th>
                      <th scope="col">Importación</th>
                      <th scope="col">Descripción</th>
                      <th scope="col">Cantidad</th>
                      <th scope="col">Tipo</th>
                      <th scope="col">Estado</th>
                      <th scope="col">Estado MTESS</th>
                      <th scope="col">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.lotesData.lotes.map((lote, index) => (
                      <tr key={index}>
                        <th scope="row">{lote.numero}</th>
                        <td>{lote.fechaImportacion}</td>
                        <td>{lote.descripcion}</td>
                        <td>{lote.cantDocumentos}</td>
                        <td>{lote.tipoDocumento}</td>
                        <td>{lote.estado}</td>
                        <td>{lote.estadoMTESS ? "Sí" : "No"}</td>
                        <td>
                          <div className="table-actions">
                            <Link
                              to={{
                                pathname: "/lote/recibos/publicar/" + lote.id,
                                state: { lote, estado: "publicar" },
                              }}
                            >
                              <a class="btn btn-secondary btn-md btn-floating">
                                <img src={visibility} />
                              </a>
                            </Link>
                            <button
                              className="btn btn-secondary btn-md btn-floating"
                              onClick={() => {
                                ;
                                this.setState({
                                  dialogTitle: "Eliminar lote",
                                  selectedRecibo: lote,
                                  dialogType: "edit",
                                  submitText: "Editar",
                                  disabledInput: false
                                }, () => {
                                  this.handleDialogEliminarLote(true);
                                });
                              }}
                              data-mdb-toggle="modal"
                              data-mdb-target="#modalEliminar"
                            >
                              <img src={deleteIcon} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div id="paginador">
                    <label>
                      Mostrar
                      <select
                        className="form-control custom-select"
                        id="maxRows"
                        name="state"
                        value={this.state.pageSize}
                        onChange={this.handlePageSizeChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                      </select>
                      resultados.
                    </label>
                    <ul className="pagination mb-0">
                      <li
                        className={`page-item ${
                          this.state.page === 0 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page - 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_left</span>
                        </a>
                      </li>
                      {this.renderPageNumbers()}
                      <li
                        className={`page-item ${
                          this.state.page === this.state.totalPages - 1
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page + 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_right</span>
                        </a>
                      </li>
                    </ul>
                  </div>
              </div>)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getLotes: (page, size, search) => dispatch(getLotes(page, size, search)),
});
const mapStateToProps = (state) => ({
  lotesData: state.lotesData,
});

export default connect(mapStateToProps, mapDispatchToProps)(LotesPublicar);
